import { Redirect, useGlobalSearchParams } from 'expo-router';

// Root level redirect to /home
export default function AppPage() {
    // Forward params from any upstream logic (e.g. HandleRedirectFromStorage)
    const params = useGlobalSearchParams();
    const hasParams = Object.keys(params).length > 0;
    return (
        <Redirect href={{ pathname: '/home', ...(hasParams && { params }) }} />
    );
}
